var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DefaultUrlSerializer } from '@angular/router';
var LowerCaseUrlSerializer = /** @class */ (function (_super) {
    __extends(LowerCaseUrlSerializer, _super);
    function LowerCaseUrlSerializer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LowerCaseUrlSerializer.prototype.parse = function (url) {
        if (url.startsWith("/login")) {
            return _super.prototype.parse.call(this, url);
        }
        else {
            return _super.prototype.parse.call(this, url.toLowerCase());
        }
    };
    return LowerCaseUrlSerializer;
}(DefaultUrlSerializer));
export { LowerCaseUrlSerializer };



// WEBPACK FOOTER //
// ./src/app/shared/Utils/LowerCaseUrlSerializer.ts.pre-build-optimizer.js